/*

poornima 09/19/2022  2701012930  Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs.
sohel  10/12/2022  2701012930  Triggers ,Trigger Group ->Added breadcrumbs,label changes,pagination changes.
sohel 10/15/2022  2701012930  Triggers ->Added Code Comments.
Suresh Peddavoora 10/26/2022 2701012930 Changed Text Field Variant from outlined to standard.
suresh peddavoora 10/28/2022 2701012930  Added Class Name for Text Fields and alignments for Buttons,
Ashraf 10/30/2022 2701012930  Added conditional field styles
Rohini 11/01/2022 2701012930  added condition for the helper text
Ashraf 11/02/2022 2701012930  removed return type field
Lalitha 11/03/2022 2701012930 changed textField placeHolderName and label
Prakash 11/03/2022 2701012930 Fixed Responsiveness for 768px - 1024px.
Dilip 11/04/2022 2701012930 Changed state for open delete popup
Sohel 11/08/2022 2701012930 prepopulate formula code
Dilip 11/14/2022 2701012930  Enable delete usage popup
lalitha 11/17/2022 2701012930 Added Autocomplete Field for status
Raghu 11/28/2022 2701012930 Responsive Field and Button alignment fixes
lalitha 12/07/2022 2701012930 added Created By field
lalitha 12/08/2022 2701012930 removed validations
akhila 12/08/2022 2701012930 adding session storage for search items
Saikrishna 12/08/2022 2698948956 Removed name fields.
lalitha 12/09/2022 2698948956 Added Created Date Field
Suresh Peddavoora 12/13/2022 2698948956 Fixed Text Field Alignment issue when Sidenav Enabled
Rohini 12/16/2022 2698948956 Fixed Buttons Alignment issue in Responsive
Sohel 12/16/2022 2698948956 map Fields changes
Prakash 12/26/2022 2698948956 Fields and Buttons Responsiveness issues.
kavyareddy 12/27/2022 2698948956 Fixed reset issue
kavyareddy 12/29/2022 2698948956 Fixed isDraft issue
Dilip 02/13/2023 2698948956 created by dropdown changes
Raghuh 02/21/2023 2698948956 changed text fields colors
Raghu 03/01/2023 2698948956 fixed new ui alignments
Prakash 03/28/2023 2698948956 fixed inputfiled alignments issue.
Prakash 04/26/2023 2698948956 fixed issue in tab view
Sohel 05/08/2023 2698948956 Fixed Rule Group Code Prepopulate Issue
Akhila 05/31/2023 2698948956 unsaved changes bug fixed
Akhila 06/07/2023 2698948956 added breadcrum code and description
Akhila 06/08/2023 2698948956 created date change to date created field and column
Ravi  06/08/2023 2698948956  rearrange search fields
Sohel 06/12/2023 2698948956  Fixed Page Break issue
Akhila 06/12/2023  2698948956 session storage bug fix in filter dashboard
Prakash 22/06/2023 2698948956 fixed alignments issues
Sohel 11/30/2023 2698948956 Fixed Unnecessary Table Render Issue
*/

import React, {useState, useContext, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import RuleGroupSearchTable from './RuleGroupSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import {
  fetchCreatedByDropDownData,
  getAllReportCreatedForData,
} from '../../../../../redux/reducers/ReportMaster';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {createdByOptions} from '../../../../../util/CreatedByForOptions';

const RuleGroupSearch = ({
  setValue,
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  setBreCode,
  setResetData,
  dataReset,
  roleDataBre,
  setRowData,
  handleClose,
  setRowSelected,
  StepperFilter,
  setShowFilterData,
  setIsCopy,
  ruleGroupCode,
  setRuleGroupCode = () => {},
  setGroupId,
  setRuleGroupId,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchFlag, setSearchFlag] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const dispatch = useDispatch();
  const {isLoading, successMsg, errorMsg, usageFilterRuleGroupData} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  // form field validation(2700268961)
  // const schema = Yup.object().shape({

  // });

  useEffect(() => {
    if (usageFilterRuleGroupData?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (usageFilterRuleGroupData?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setValue(2);
    }
  }, [usageFilterRuleGroupData]);

  // reset values(2700268961)
  useEffect(() => {
    if (!StepperFilter) {
      setValue && setValue(0);
      setIsDelete(false);
      setCustomError(false);
      setRowSelected(false);
    }
  }, []);

  // submit search Data(2700268961)
  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
    if (!StepperFilter) {
      sessionStorage.setItem('FilterRules', JSON.stringify(data));
    }
  };
  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];
  const SearchSessionFilterRules = JSON.parse(sessionStorage.getItem('FilterRules'));
  // form initial values(2700268961)
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: StepperFilter ? ruleGroupCode : '',
    returnType: '',
    isDraft: StepperFilter ? {key: 'N', value: 'Completed'} : '',
    createdBy: '',
    createdDate: null,
  };
  useEffect(() => {
    if(StepperFilter){
      setSearchData({
        ...initialValues,
        code: ruleGroupCode,
        isDraft: StepperFilter ? {key: 'N', value: 'Completed'} : '',
      });
      setSubmit(true);
    }
  }, [ruleGroupCode]);
  useEffect(() => {
    handleDirty && handleDirty(false, 'reset');
  }, []);
  // reset form values(2700268961)
  const onClear = () => {
    const data = {
      category: '',
      displayName: '',
      globalField: '',
      description: '',
      tableName: '',
      tableField: '',
      fieldType: '',
      code: '',
      returnType: '',
      isDraft: StepperFilter ? {key: 'N', value: 'Completed'} : '',
      createdBy: '',
      createdDate: null,
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData('datacalculation'));
  }, [dispatch]);
  return (
    <div>
      <h2 className="search-title">Filter Rules Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={
          !StepperFilter && SearchSessionFilterRules ? SearchSessionFilterRules : initialValues
        }
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            touched,
            values,
            setFieldValue,
            handleChange,
            handleReset,
            handleBlur,
            errors,
          } = props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <div>
                  <ErrorBoundaryForComponents>
                    <div className="form-row new-standard-textfields mt-3">
                      <div
                        className={`col-sm-6 col-md-4 col-lg-3 col-xl-2 account-guarantor ${
                          errors?.code?.length > 30 ? 'adduser-password-fields' : 'form-group'
                        }`}
                      >
                        <TextField
                          margin="dense"
                          // variant={`${handleClose ? "outlined" : "standard"}`}
                          variant="outlined"
                          className={` ${classes.labelName}`}
                          InputLabelProps={
                            handleClose ?
                              {
                                shrink: true,
                              } :
                              '' 
                          }
                          placeholder={`Enter Filter Name`}
                          label="Filter Name"
                          name="code"
                          value={values?.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      {/* <div className="col-sm-6 col-md-4 col-lg-2 form-group">
                        <TextField
                          margin="dense"
                          variant={`${handleClose ? "outlined" : "standard"}`}
                          className={` ${handleClose ? classes.labelName : ""} ${
                            handleClose ? classes.inputLabel : ""
                          }`}
                          InputLabelProps={
                            handleClose
                              ? {
                                shrink: true,
                              }
                              : ""
                          }
                          placeholder={`Enter Filter Name`}
                          label="Filter Name"
                          name="displayName"
                          value={values.displayName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div> */}
                      <div className="col-sm-6 col-md-4 col-lg-4  form-group account-guarantor">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={` ${classes.labelName}`}
                          InputLabelProps={
                            handleClose ?
                              {
                                shrink: true,
                              } :
                              ''
                          }
                          placeholder={`Enter Filter Description`}
                          label="Filter Description"
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-2 col-lg-3 form-group account-guarantor">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group account-guarantor start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-2 form-group account-guarantor">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          name="isDraft"
                          id="isDraft"
                          size="small"
                          options={StatusOptions}
                          disabled={StepperFilter}
                          required
                          value={values.isDraft}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('isDraft', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-xl-12  form-group">
                        <div className="d-flex align-items-center justify-content-xl-center justify-content-lg-start justify-content-md-center">
                          <Button
                            variant="outlined"
                            className={` reset-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData(initialValues);
                              setSubmit(true);
                              onClear();
                              setRuleGroupCode('');
                              // setGroupId('');
                              sessionStorage.removeItem('FilterRules');
                              StepperFilter && setFieldValue('code', '');
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </div>
          );
        }}
      </Formik>
      <RuleGroupSearchTable
        setResetData={setResetData}
        setValue={setValue}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        searchFlag={searchFlag}
        setBreCode={setBreCode}
        submit={submit}
        handleClose={handleClose}
        setSubmit={setSubmit}
        dataReset={dataReset}
        roleDataBre={roleDataBre}
        setRowData={setRowData}
        setDeleteUsage={setDeleteUsage}
        userMetrixDelete={userMetrixDelete}
        isDelete={isDelete}
        setIsDelete={setIsDelete}
        isUsage={isUsage}
        setIsUsage={setIsUsage}
        setRowSelected={setRowSelected}
        StepperFilter={StepperFilter}
        setShowFilterData={setShowFilterData}
        setUserMetrixDelete={setUserMetrixDelete}
        setIsCopy={setIsCopy}
        ruleGroupCode={ruleGroupCode}
        setRuleGroupCode={setRuleGroupCode}
        setGroupId={setGroupId}
        setRuleGroupId={setRuleGroupId}
      />
      {customError && <WarningSnackbar errorMsg={'This filter rule is not being used anywhere'} />}
    </div>
  );
};

export default RuleGroupSearch;
